export const isNumeric = (str) => {
  if (typeof str === 'number') return true;
  return !Number.isNaN(str) && !Number.isNaN(parseFloat(str));
};

// Ad markup and URLs come from third-party servers: only plain web links are opened or framed,
// never a `javascript:` URL that would run in this page's origin.
export const isHttpUrl = (url) => typeof url === 'string' && /^https?:\/\//i.test(url.trim());

export const getLocalISOString = (date) => {
  const offset = date.getTimezoneOffset();
  const offsetAbs = Math.abs(offset);
  const isoString = new Date(date.getTime() - offset * 60 * 1000).toISOString();
  return `${isoString.slice(0, -1)}${offset > 0 ? '-' : '+'}${String(Math.floor(offsetAbs / 60)).padStart(2, '0')}`;
};

export const convertTimeOffsetToSeconds = (timecode, duration = null) => {
  if (duration && timecode.includes('%')) {
    return (duration / 100) * parseFloat(timecode);
  }
  if (timecode.includes('#')) {
    return parseFloat(timecode.replace('#', ''));
  }
  const [time, ms] = timecode.split('.');
  const [hours, minutes, seconds] = time.split(':');
  return Number(`${parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60 + parseInt(seconds, 10)}.${ms || '0'}`);
};

// Parse "HH:MM:SS" or "HH:MM:SS.mmm" to seconds
export const parseDuration = (str) => {
  if (!str) return 0;
  const parts = str.split(':');
  if (parts.length !== 3) return 0;
  return parseFloat(parts[0]) * 3600 + parseFloat(parts[1]) * 60 + parseFloat(parts[2]);
};